import InputChoicesTab from "./sub_tabs/InputChoicesTab";

const castingChoicesRouter = {

  choices: 
  {
    title: 'Choices',
    element: <InputChoicesTab />
  }

}

export default castingChoicesRouter;